export const routes = (prefix = `profile`) => [
    {
        path: `/${prefix}/statement`,
        name: `${prefix}.statement.index`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
        },
    },
];
